/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lesson_NotificationsInputs */

const en_lesson_notifications = /** @type {(inputs: Lesson_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scheduled notifications`)
};

const he_lesson_notifications = /** @type {(inputs: Lesson_NotificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`התראות מתוזמנות`)
};

/**
* | output |
* | --- |
* | "Scheduled notifications" |
*
* @param {Lesson_NotificationsInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const lesson_notifications = /** @type {((inputs?: Lesson_NotificationsInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lesson_NotificationsInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lesson_notifications(inputs)
	return he_lesson_notifications(inputs)
});